module.exports = "/_next/static/images/d2bb08d02c569f81e35185f76bd6d516-device-frame-dark@3x.png";